// Mock data for Atelier de Murat clone

// Nutrition values common to all 12 pastries (source: Catalogue Pâtisserie 2019)
const pastryNutrition = {
  energy: '1557 kJ / 370 Kcal',
  fat: '11 g',
  sat: '4,8 g',
  carbs: '63 g',
  sugars: '40 g',
  protein: '4,4 g',
  salt: '0,19 g'
};

export const pastries = [
  {
    id: 1,
    num: '01',
    name: 'Baklava',
    subtitle: 'Noix ou Pistache d\u2019Antep',
    image: 'https://customer-assets-eiarnc6j.emergentagent.net/job_murat-sweet/artifacts/8195vn7u_BAKLAVA.png',
    description: 'Un classique. \u00c0 base de p\u00e2tes feuillet\u00e9es, garni de noix ou de pistache, son croustillant et son go\u00fbt en ont fait un best-seller.',
    ingredients: 'P\u00e2tes feuillet\u00e9es (farine de bl\u00e9, amidon de ma\u00efs, eau, sel), noix ou pistache (selon demande), huile v\u00e9g\u00e9tale, sirop de sucre.',
    allergens: 'Gluten, fruits \u00e0 coque.',
    nutrition: pastryNutrition,
    conditioning: { pb: '15 pi\u00e8ces', gb: '30 pi\u00e8ces', tgb: '60 pi\u00e8ces' }
  },
  {
    id: 2,
    num: '02',
    name: 'Baklava triangle',
    subtitle: 'Noix',
    image: 'https://customer-assets-eiarnc6j.emergentagent.net/job_murat-sweet/artifacts/xfss67oi_Baklava%20dor%C3%A9e%20aux%20pistaches%20sur%20fond%20blanc.png',
    imagePosition: 'center 32%',
    description: 'Une variante triangulaire du baklava : m\u00eame feuilletage dor\u00e9 et croustillant, garni g\u00e9n\u00e9reusement de noix.',
    ingredients: 'P\u00e2tes feuillet\u00e9es (farine de bl\u00e9, amidon de ma\u00efs, eau, sel), noix, huile v\u00e9g\u00e9tale, sirop de sucre.',
    allergens: 'Gluten, fruits \u00e0 coque.',
    nutrition: pastryNutrition,
    conditioning: { pb: '8 pi\u00e8ces', gb: '18 pi\u00e8ces', tgb: '' }
  },
  {
    id: 3,
    num: '03',
    name: 'Ye\u015fil',
    subtitle: '100% Pistache d\u2019Antep \u00b7 sur commande',
    image: 'https://customer-assets-eiarnc6j.emergentagent.net/job_murat-sweet/artifacts/3yerc868_YESIL.png',
    description: 'Un feuillet\u00e9 garni enti\u00e8rement de pistache d\u2019Antep. Uniquement sur commande.',
    ingredients: 'P\u00e2tes feuillet\u00e9es (farine de bl\u00e9, amidon de ma\u00efs, eau, sel), pistache, huile v\u00e9g\u00e9tale, sirop de sucre.',
    allergens: 'Gluten, fruits \u00e0 coque.',
    nutrition: pastryNutrition,
    conditioning: { pb: 'Sur commande', gb: '35 pi\u00e8ces', tgb: '70 pi\u00e8ces' }
  },
  {
    id: 4,
    num: '04',
    name: 'Cigare',
    subtitle: 'Noix ou Pistache d\u2019Antep',
    image: 'https://customer-assets-eiarnc6j.emergentagent.net/job_murat-sweet/artifacts/kw52kncl_CIGARE.png',
    description: 'Un feuilletage \u00e9pais et croustillant garni de noix de cajou ou de pistache d\u2019Antep.',
    ingredients: 'P\u00e2tes feuillet\u00e9es (farine de bl\u00e9, amidon de ma\u00efs, eau, sel), noix de cajou ou pistache (selon demande), huile v\u00e9g\u00e9tale, sirop de sucre.',
    allergens: 'Gluten, fruits \u00e0 coque.',
    nutrition: pastryNutrition,
    conditioning: { pb: '14 pi\u00e8ces', gb: '28 pi\u00e8ces', tgb: '56 pi\u00e8ces' }
  },
  {
    id: 5,
    num: '05',
    name: 'Kadayif',
    subtitle: 'Noix ou Pistache d\u2019Antep',
    image: 'https://customer-assets-eiarnc6j.emergentagent.net/job_murat-sweet/artifacts/0ltzyvlz_KADAIF.png',
    description: 'Des cheveux d\u2019anges assembl\u00e9s avec soin, garnis de noix de cajou ou de pistache : une p\u00e2tisserie unique par sa pr\u00e9sentation et son croustillant.',
    ingredients: 'Cheveux d\u2019anges (farine de bl\u00e9, amidon de ma\u00efs, eau, sel, conservateur E202), noix de cajou ou pistache (selon demande), huile v\u00e9g\u00e9tale, sirop de sucre.',
    allergens: 'Gluten, fruits \u00e0 coque.',
    nutrition: pastryNutrition,
    conditioning: { pb: '6 pi\u00e8ces', gb: '14 pi\u00e8ces', tgb: '28 pi\u00e8ces' }
  },
  {
    id: 6,
    num: '06',
    name: 'Saray',
    subtitle: 'Noix ou Pistache d\u2019Antep',
    image: 'https://customer-assets-eiarnc6j.emergentagent.net/job_murat-sweet/artifacts/co1q2xyd_SARAY.png',
    description: 'Un roul\u00e9 de p\u00e2te feuillet\u00e9e garni de noix de cajou ou de pistache \u2014 un incontournable de la p\u00e2tisserie orientale.',
    ingredients: 'P\u00e2tes feuillet\u00e9es (farine de bl\u00e9, amidon de ma\u00efs, eau, sel), noix de cajou ou pistache (selon demande), huile v\u00e9g\u00e9tale, sirop de sucre.',
    allergens: 'Gluten, fruits \u00e0 coque.',
    nutrition: pastryNutrition,
    conditioning: { pb: '20 pi\u00e8ces', gb: '40 pi\u00e8ces', tgb: '80 pi\u00e8ces' }
  },
  {
    id: 7,
    num: '07',
    name: 'D\u00fcr\u00fcm',
    subtitle: 'Noix de cajou & amande',
    image: 'https://customer-assets-eiarnc6j.emergentagent.net/job_murat-sweet/artifacts/sf8g5a09_DURUM.png',
    description: 'De fines feuilles de p\u00e2te enroul\u00e9es sur elles-m\u00eames, des noix de cajou et une amande croquante.',
    ingredients: 'P\u00e2tes feuillet\u00e9es (farine de bl\u00e9, amidon de ma\u00efs, eau, sel), noix de cajou, amande, huile v\u00e9g\u00e9tale, sirop de sucre.',
    allergens: 'Gluten, fruits \u00e0 coque.',
    nutrition: pastryNutrition,
    conditioning: { pb: '12 pi\u00e8ces', gb: '24 pi\u00e8ces', tgb: '48 pi\u00e8ces' }
  },
  {
    id: 8,
    num: '08',
    name: '\u015eekerpare',
    subtitle: 'Sabl\u00e9 \u00e0 l\u2019amande',
    image: 'https://customer-assets-eiarnc6j.emergentagent.net/job_murat-sweet/artifacts/a5bo97vd_SEKERPARE.png',
    description: 'Un sabl\u00e9 imbib\u00e9 de sirop de sucre qui donne au \u015fekerpare une texture fondante et croquante gr\u00e2ce \u00e0 une fine amande.',
    ingredients: 'Semoule, sucre glace, sirop de sucre, amandes, farine.',
    allergens: 'Gluten, fruits \u00e0 coque.',
    nutrition: pastryNutrition,
    conditioning: { pb: '12 pi\u00e8ces', gb: '24 pi\u00e8ces', tgb: '48 pi\u00e8ces' }
  },
  {
    id: 9,
    num: '09',
    name: '\u015e\u00f6biyet',
    subtitle: 'Noix de cajou ou Pistache',
    image: 'https://customer-assets-eiarnc6j.emergentagent.net/job_murat-sweet/artifacts/nm6ys7v9_SOBIYET.png',
    description: 'Avec sa forme triangulaire, le \u015f\u00f6biyet est une p\u00e2tisserie gourmande et extr\u00eamement croquante, garnie de noix de cajou ou de pistache.',
    ingredients: 'P\u00e2tes feuillet\u00e9es (farine de bl\u00e9, amidon de ma\u00efs, eau, sel), noix de cajou ou pistache, huile v\u00e9g\u00e9tale, sirop de sucre.',
    allergens: 'Gluten, fruits \u00e0 coque.',
    nutrition: pastryNutrition,
    conditioning: { pb: '12 pi\u00e8ces', gb: '24 pi\u00e8ces', tgb: '48 pi\u00e8ces' }
  },
  {
    id: 10,
    num: '10',
    name: 'Tulumba',
    subtitle: 'Nature',
    image: 'https://customer-assets-eiarnc6j.emergentagent.net/job_murat-sweet/artifacts/vhpfnkqd_TULUMBA.png',
    description: 'Aussi appel\u00e9s les churros de la cuisine m\u00e9diterran\u00e9enne : cuisin\u00e9s \u00e0 base de farine s\u00e9lectionn\u00e9e par nos soins, d\u2019\u0153ufs et de sirop de sucre.',
    ingredients: 'Farine, sel, eau, \u0153uf, sirop de sucre.',
    allergens: 'Gluten, \u0153ufs.',
    nutrition: pastryNutrition,
    conditioning: { pb: '500 g', gb: '1,2 kg', tgb: '2,4 kg' }
  }
];

export const timeline = [
  {
    year: '1985',
    title: 'La fondation',
    text: 'L\u2019Atelier de Murat voit le jour avec l\u2019ambition de partager les saveurs authentiques de la cuisine m\u00e9diterran\u00e9enne et de faire vivre un savoir-faire traditionnel.'
  },
  {
    year: '2014',
    title: 'Le renouveau',
    text: 'Renouvellement complet de notre outil industriel : la tradition artisanale rencontre l\u2019exigence moderne, sans jamais renier la recette unique.'
  },
  {
    year: 'Aujourd\u2019hui',
    title: 'Partout en France',
    text: 'Depuis plus de 20 ans l\u2019atelier de Murat s\u2019efforce de proposer aux grossistes, aux enseignes de la distribution, aux professionnels de la restauration et aux consommateurs des p\u00e2tisseries de tr\u00e8s grande qualit\u00e9.'
  }
];

export const ingredients = [
  { name: 'Pistaches d\u2019Antep', image: 'https://images.unsplash.com/photo-1551238875-13b9d38454db?crop=entropy&cs=srgb&fm=jpg&q=85&w=600' },
  { name: 'Noix de cajou du Br\u00e9sil', image: 'https://images.unsplash.com/photo-1723466998040-78d7e2ef6d72?crop=entropy&cs=srgb&fm=jpg&q=85&w=600' },
  { name: 'Noix de France', image: 'https://images.unsplash.com/photo-1635843108103-9af0ea224a19?crop=entropy&cs=srgb&fm=jpg&q=85&w=600' },
  { name: 'Amandes', image: 'https://images.unsplash.com/photo-1600188999986-331bec5f9a8d?crop=entropy&cs=srgb&fm=jpg&q=85&w=600' }
];

export const marqueeItems = [
  'Depuis 1985',
  'Fabrication fran\u00e7aise',
  'Pistaches d\u2019Antep',
  'Noix de cajou du Br\u00e9sil',
  'Noix de France'
];

export const seasonalBanner = {
  // Toggle master on/off
  enabled: false,
  // Change this `key` whenever you edit the message to re-show the banner to returning visitors
  key: 'ramadan-2026',
  // Optional display window (ISO format YYYY-MM-DD). Leave as null to show as soon as enabled is true.
  // The banner will auto-show between startDate (00:00) and endDate (23:59), both inclusive.
  startDate: null, // e.g. '2026-02-15'
  endDate: null,   // e.g. '2026-03-20'
  fr: {
    tag: 'Ramadan 2026',
    message: 'Commandes spéciales ouvertes — réservez vos pâtisseries dès maintenant pour l’Iftar.',
    cta: 'Nous contacter'
  },
  en: {
    tag: 'Ramadan 2026',
    message: 'Special orders are now open — reserve your pastries for Iftar.',
    cta: 'Contact us'
  }
};

export const production = {
  intro: 'Les p\u00e2tes que nous fabriquons sont \u00ab vivantes \u00bb. Elles r\u00e9agissent \u00e0 la variation de la temp\u00e9rature, \u00e0 l\u2019humidit\u00e9\u2026 Tous les param\u00e8tres de production sont constamment surveill\u00e9s et ajust\u00e9s en fonction de \u00ab l\u2019humeur \u00bb de nos p\u00e2tes.',
  commitment: 'Nous nous effor\u00e7ons de garantir \u00e0 nos clients des produits de qualit\u00e9 \u00e0 travers :',
  points: [
    'Des partenaires ancr\u00e9s dans l\u2019histoire de notre entreprise',
    'Des mati\u00e8res premi\u00e8res s\u00e9lectionn\u00e9es',
    'Notre outil industriel renouvel\u00e9 en 2014',
    'Les contr\u00f4les qualit\u00e9 \u00e0 chaque \u00e9tape de fabrication et la tra\u00e7abilit\u00e9 compl\u00e8te des produits',
    'Un conditionnement sous atmosph\u00e8re protectrice avec emballages barri\u00e8re \u00e0 oxyg\u00e8ne pour garantir la conservation et la fra\u00eecheur'
  ],
  machines: [
    { count: '2', label: 'Thermo', sublabel: 'formeuses' },
    { count: '1', label: 'Machine', sublabel: '\u00e0 Yufka' },
    { count: '1', label: 'Machine \u00e0 Kadayif', sublabel: '\u00e0 2 t\u00eates' },
    { count: '2', label: 'Machines', sublabel: '\u00e0 Filo' }
  ]
};

export const pates = [
  {
    id: 1,
    tag: 'Fines & croustillantes',
    name: 'P\u00e2te \u00e0 Filo',
    subtitle: 'Baklava, beurek & croustillant',
    weight: '500 g',
    image: 'https://customer-assets-eiarnc6j.emergentagent.net/job_murat-sweet/artifacts/k6s47u2p_FILO.webp',
    description: 'Les p\u00e2tes \u00e0 Filo Murat ont \u00e9t\u00e9 con\u00e7ues pour donner un croustillant et une l\u00e9g\u00e8ret\u00e9 unique aux recettes sucr\u00e9es et sal\u00e9es les plus gourmandes : feuillet\u00e9es, mille-feuilles, tartes, p\u00e2tisseries. En entr\u00e9e, plat ou dessert.',
    ingredients: 'Farine de bl\u00e9, eau, amidon de ma\u00efs, sel, conservateur : sorbate de potassium, agent de traitement de la farine : L-cyst\u00e9ine (origine v\u00e9g\u00e9tale).',
    nutrition: {
      energy: '1264 kJ / 297 Kcal',
      fat: '0,7 g',
      sat: '0,2 g',
      carbs: '63,6 g',
      sugars: '2,7 g',
      protein: '8,9 g',
      salt: '0,4 g'
    },
    conditioning: {
      shelfLife: '120 jours',
      storage: '+4\u00b0C / +8\u00b0C',
      packaging: 'Conditionn\u00e9 sous atmosph\u00e8re protectrice',
      cartons: '20 unit\u00e9s / carton',
      pallet: '48 cartons / palette'
    }
  },
  {
    id: 2,
    tag: 'Les cheveux d\u2019anges',
    name: 'P\u00e2te \u00e0 Kada\u00efyif',
    subtitle: 'Kadayif Teigf\u00e4den \u00b7 Taze Kadayif',
    weight: '500 g',
    image: 'https://customer-assets-eiarnc6j.emergentagent.net/job_murat-sweet/artifacts/69xdfjlr_KADAIF.jpeg',
    description: 'G\u00e9n\u00e9reuse et dor\u00e9e, la p\u00e2te \u00e0 Kada\u00efyif Murat se laisse \u00e9taler et garnir au gr\u00e9 de l\u2019imagination pour r\u00e9aliser des recettes originales ou traditionnelles, toujours croustillantes.',
    ingredients: 'Farine de bl\u00e9 (gluten), eau, amidon de ma\u00efs, huile de tournesol, sel, l\u00e9cithine de soja, conservateur : sorbate de potassium.',
    nutrition: {
      energy: '1274 kJ / 301 Kcal',
      fat: '2,4 g',
      sat: '0,4 g',
      carbs: '64,3 g',
      sugars: '2,5 g',
      protein: '4,8 g',
      salt: '0,5 g'
    },
    conditioning: {
      shelfLife: '120 jours',
      storage: '+4\u00b0C / +8\u00b0C',
      packaging: 'Conditionn\u00e9 sous atmosph\u00e8re protectrice',
      cartons: '12 unit\u00e9s / carton',
      pallet: '48 cartons / palette'
    }
  },
  {
    id: 3,
    tag: 'Pour toutes vos recettes de b\u00f6rek',
    name: 'Sa\u00e7 Yufka',
    subtitle: 'P\u00e2te feuillet\u00e9e pour pr\u00e9paration sal\u00e9e',
    weight: '400 g',
    image: 'https://customer-assets-eiarnc6j.emergentagent.net/job_murat-sweet/artifacts/8wsqxanz_SA%C3%87.jpeg',
    description: 'D\u00e9roulez votre p\u00e2te, elle est d\u00e9j\u00e0 pr\u00eate \u00e0 \u00eatre garnie. Fromage, \u00e9pinards, viandes hach\u00e9es ou pommes de terre : variez les recettes et accompagnez vos b\u00f6reks d\u2019une salade verte et de tomate.',
    ingredients: 'Farine de bl\u00e9 (gluten), eau, sel, \u00e9paississant : E412, conservateur : sorbate de potassium.',
    nutrition: {
      energy: '1247 kJ / 294 Kcal',
      fat: '0,7 g',
      sat: '0,1 g',
      carbs: '62,9 g',
      sugars: '1,5 g',
      protein: '0,2 g',
      salt: '1,8 g'
    },
    conditioning: {
      shelfLife: '150 jours',
      storage: '+4\u00b0C',
      packaging: 'Conditionn\u00e9 sous atmosph\u00e8re protectrice',
      cartons: '16 unit\u00e9s / carton',
      pallet: '60 cartons / palette'
    }
  },
  {
    id: 4,
    tag: 'Croustillantes & d\u00e9licieuses',
    name: '\u00dc\u00e7gen Yufka',
    subtitle: 'P\u00e2tes feuillet\u00e9es pour pr\u00e9parations sal\u00e9es',
    weight: '360 g',
    image: 'https://customer-assets-eiarnc6j.emergentagent.net/job_murat-sweet/artifacts/df86al31_UCGEN.jpeg',
    description: 'Pr\u00e9d\u00e9coup\u00e9e en triangles, l\u2019\u00dc\u00e7gen Yufka facilite la pr\u00e9paration des b\u00f6reks \u00e0 la cha\u00eene pour une cuisson homog\u00e8ne et dor\u00e9e.',
    ingredients: 'Farine de bl\u00e9 (gluten), eau, sel, \u00e9paississant : E412, conservateur : sorbate de potassium.',
    nutrition: {
      energy: '1247 kJ / 294 Kcal',
      fat: '0,7 g',
      sat: '0,1 g',
      carbs: '62,9 g',
      sugars: '1,5 g',
      protein: '0,2 g',
      salt: '1,8 g'
    },
    conditioning: {
      shelfLife: '150 jours',
      storage: '+4\u00b0C',
      packaging: 'Conditionn\u00e9 sous atmosph\u00e8re protectrice',
      cartons: '16 unit\u00e9s / carton',
      pallet: '60 cartons / palette'
    }
  },
  {
    id: 5,
    tag: 'Pr\u00eate \u00e0 garnir',
    name: 'Uzun Yufka',
    subtitle: 'P\u00e2te longue pour pr\u00e9parations sal\u00e9es',
    weight: '400 g',
    image: 'https://customer-assets-eiarnc6j.emergentagent.net/job_murat-sweet/artifacts/owyrr89w_UZUN%20YUKFA.jpeg',
    description: 'Longue et souple, l\u2019Uzun Yufka se roule et se garnit facilement pour pr\u00e9parer des b\u00f6reks g\u00e9n\u00e9reux \u00e0 partager.',
    ingredients: 'Farine de bl\u00e9 (gluten), eau, sel, \u00e9paississant : E412, conservateur : sorbate de potassium.',
    nutrition: {
      energy: '1247 kJ / 292 Kcal',
      fat: '0,7 g',
      sat: '0,2 g',
      carbs: '63,7 g',
      sugars: '0,5 g',
      protein: '9,3 g',
      salt: '1,3 g'
    },
    conditioning: {
      shelfLife: '150 jours',
      storage: '+4\u00b0C / +8\u00b0C',
      packaging: 'Conditionn\u00e9 sous atmosph\u00e8re protectrice',
      cartons: '16 unit\u00e9s / carton',
      pallet: '60 cartons / palette'
    }
  }
];
